import * as csv from 'csv-parser';
import * as streams from 'memory-streams';
import GeneratorEntity from '../models/Generator';

export function importCsv(name: string, text: string, callback: (generator: GeneratorEntity | null, error: Error | null) => void) {
  const columns = {};

  const rs = new streams.ReadableStream('');
  rs.pipe(csv({
    mapHeaders: ({ header, index }) => header.trim(),
    mapValues: ({ header, index, value }) => value.trim()
  }))
    .on('data', (row: object) => {
      const names = Object.getOwnPropertyNames(row);
      names.forEach(n => {
        if (!columns[n]) {
          columns[n] = [];
        }
        columns[n].push(row[n]);
      });
    })
    .on('end', () => {
      const names = Object.getOwnPropertyNames(columns);

      const generator = new GeneratorEntity();
      generator.name = name;
      generator.categories = names;
      generator.resultPattern = names.map(n => `{${n}}`).join(' ');
      generator.tables = names.map(n => ({
        entries: columns[n],
        name: n
      }));

      callback(generator, null);
    })
    .on('error', (error: Error) => {
      callback(null, error);
    });

  rs.push(text);
  rs.push(null);
}



// WEBPACK FOOTER //
// ./src/utils/importCsv.ts